export default "__VITE_ASSET__DyUTlrBU__"